
// Defines the different stages that
// we go through when collecting
// data.
export const DATA_COLLECTION_STAGES = {
  noRequest: "no_request",
  collecting: "collecting_data",
  collected: "data_collected"
}
